import React from "react"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap"
import classnames from "classnames"
import { Eye, Code } from "react-feather"
import { pillActiveBorder } from "../../theme/reactstrap/tabPills/TabPillsSourceCode";

class CustomPill extends React.Component {
  state = {
    activeTab: "1",
    active: "1"
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  toggle = tab => {
    if (this.state.active !== tab) {
      this.setState({ active: tab })
    }
  }
  render() {
    return (
      <React.Fragment>
        <TabContent className="py-50" activeTab={this.state.activeTab} style={{width: "80%", margin: "0 auto"}}>
          <TabPane tabId="1">
            <Nav pills className="nav-active-bordered-pill d-flex justify-content-around align-items-center flex-wrap">
                  {
                  this.props.tabsContent.length
                    ? this.props.tabsContent.map((item, index) => {
                      return (
                        <NavItem key={index}>
                          <NavLink
                            className={classnames({
                              active: this.state.active === item.key
                            })}
                            onClick={() => {
                              this.toggle(item.key)
                            }}
                          >
                            {item.tab_name}
                          </NavLink>
                        </NavItem>
                      )
                    })
                    : null
                }
              </Nav>
              <hr />
            <TabContent className="mt-2" activeTab={this.state.active}>
              {
                this.props.tabsContent.length
                  ? this.props.tabsContent.map((item, index) => {
                    return (
                      <TabPane key={index} tabId={item.key}>
                        {item.tab_content}
                      </TabPane>
                    )
                  })
                  : null
              }
            </TabContent>
          </TabPane>
          <TabPane className="component-code" tabId="2">
            {pillActiveBorder}
          </TabPane>
        </TabContent>
      </React.Fragment>
    )
  }
}
export default CustomPill;
